<template>
  <div v-if="store.form.currentStep === 'stepThree' || store.debug">
    <Steps class="mt-4 mt-md-0" @finishStepEmit="finishStepEmit"/>

    <hr class="d-md-none ml-4 mr-4">
    <div class="pl-3 pl-lg-0">
      <div class="pb-4 pr-3 pr-md-4 text-right">


        <div class="row text-left">
          <span class="h6 col-12 text-primary mt-3 mb-2 font-weight-bold">{{
              t('personalForm.headers.fakturacniUdaje')
            }}</span>

          <div class="col-12 my-3">
            <div class="custom-control custom-checkbox">
              <input class="custom-control-input"
                     v-model="store.form.sameInvoiceAddressOwnSeat" type="checkbox" value=""
                     id="checkAgreement"
                     v-on:change="sameInvoiceAddressCheckBoxChanged()">
              <label class="custom-control-label" for="checkAgreement" v-if="store.form.mamIco === 'mam'">
                <span v-if="store.form.osoba === 'pravnicka'">{{ t('personalForm.fakturovatNaStejnouFirmu') }}</span>
                <span v-if="store.form.osoba === 'fyzicka'">{{ t('personalForm.fakturovatNaStejnouOsvc') }}</span>
              </label>
              <label class="custom-control-label" for="checkAgreement" v-if="store.form.mamIco === 'nemam'">
                <span v-if="store.form.osoba === 'pravnicka'">{{ t('personalForm.fakturovatNaNovouFirmu') }}</span>
                <span v-if="store.form.osoba === 'fyzicka'">{{ t('personalForm.fakturovatNaNovouOsvc') }}</span>
              </label>
            </div>
          </div>


<!--          INPUT ICO -->
          <div class="col-12 col-sm-6" v-if="store.form.mamIco === 'mam'">
              <div class="form-label-group mb-1">
                <input type="text" id="ico" class="form-control"
                       :class="{'is-invalid': isBlurred() && (!store.order.contactInfo.address.invoiceAddress.ico || store.order.contactInfo.address.invoiceAddress.ico.length < 8)}"
                       v-model="store.order.contactInfo.address.invoiceAddress.ico"
                       v-on:input="preventIcoInputFromLetter"
                       placeholder="{{ t('personalForm.ico') }}"
                       required=""
                       :disabled="store.form.sameInvoiceAddressOwnSeat"/>
                <label for="postCode"> {{ t('personalForm.ico') }}</label>

                <button
                        class="ares-button py-0 btn btn-sm btn-outline-primary text-uppercase"
                        v-on:click="loadFromAres"
                        :disabled="store.form.sameInvoiceAddressOwnSeat || aresLoading">
                  {{ t('buttons.loadFromAres') }}
                </button>

<!--                <button v-if="store.order.contactInfo.address.invoiceAddress.ico.length === 8 && !aresLoading"-->
<!--                        class="ares-button py-0 btn btn-sm btn-outline-danger"-->
<!--                        v-on:click="loadFromAres"-->
<!--                        :disabled="store.form.sameInvoiceAddressOwnSeat">-->
<!--                  {{ t('buttons.loadFromAres') }}-->
<!--                </button>-->
<!--                <span v-if="aresLoading" class="ares-button py-0 text-danger px-2 border border-danger">-->
<!--                    {{ t('personalForm.loading') }}...-->
<!--              </span>-->
                <div id="validationServer05Feedback" class="invalid-feedback">
                  {{ t('personalForm.required.ico') }}
                </div>
              </div>

<!--            <InputText v-if="store.form.sameInvoiceAddressOwnSeat" v-model="store.order.contactInfo.address.companyAddress.ico" label-name="personalForm.ico"-->
<!--                       id="surName"-->
<!--                       required="personalForm.required.ico" step="stepThree" disabled="disabled"/>-->
          </div>
<!--          INPUT ICO END-->

<!--          INPUT DIC-->
          <div class="col-12 col-sm-6" v-if="store.form.mamIco === 'mam'">
            <InputText v-if="!store.form.sameInvoiceAddressOwnSeat" v-model="store.order.contactInfo.address.invoiceAddress.dic" label-name="personalForm.dic"
                       id="surName"
                       step="stepThree"/>
            <InputText v-if="store.form.sameInvoiceAddressOwnSeat" v-model="store.order.contactInfo.address.companyAddress.dic" label-name="personalForm.dic"
                       id="surName"
                      step="stepThree" disabled="disabled"/>
          </div>

<!--          INPUT COMPANY NAME-->
          <div class="col-12 col-sm-6" v-if="store.form.osoba === 'pravnicka'">
            <InputText v-if="!store.form.sameInvoiceAddressOwnSeat" v-model="store.order.contactInfo.address.invoiceAddress.companyName"
                       :label-name="store.form.mamIco === 'mam' ? 'personalForm.companyName' : 'personalForm.companyNameNoIco'"
                       id="surName"
                       required="personalForm.required.companyName" step="stepThree"/>
            <InputText v-else v-model="store.order.contactInfo.address.companyAddress.companyName"
                       :label-name="store.form.mamIco === 'mam' ? 'personalForm.companyName' : 'personalForm.companyNameNoIco'"
                       id="surName"
                       required="personalForm.required.companyName" step="stepThree" :disabled="store.form.sameInvoiceAddressOwnSeat ? 'disabled' : null"/>
          </div>

<!--          INPUT OSVC NAME-->
          <div class="col-12 col-sm-6" v-if="store.form.osoba === 'fyzicka'">
            <InputText v-if="!store.form.sameInvoiceAddressOwnSeat" v-model="store.order.contactInfo.address.invoiceAddress.companyName"
                       :label-name="store.form.mamIco === 'mam' ? 'personalForm.osvcName' : 'personalForm.osvcNameNoIco'"
                       id="surName"
                       required="personalForm.required.osvcName" step="stepThree"/>
            <InputText v-else v-model="store.order.contactInfo.address.companyAddress.companyName"
                       :label-name="store.form.mamIco === 'mam' ? 'personalForm.osvcName' : 'personalForm.osvcNameNoIco'"
                       id="surName"
                       required="personalForm.required.osvcName"
                       step="stepThree"
                       :disabled="store.form.sameInvoiceAddressOwnSeat ? 'disabled' : null"/>
          </div>

<!--          INPUT STREET-->
          <div class="col-12 col-sm-6">
            <InputText v-if="!store.form.sameInvoiceAddressOwnSeat" v-model="store.order.contactInfo.address.invoiceAddress.street" label-name="personalForm.street"
                       id="street"
                       required="personalForm.required.street" step="stepThree"/>
            <InputText v-if="store.form.sameInvoiceAddressOwnSeat" v-model="store.order.contactInfo.address.invoiceAddress.street" label-name="personalForm.street"
                       id="street"
                       required="personalForm.required.street" step="stepThree" disabled="disabled"/>
          </div>

<!--          INPUT CITY-->
          <div class="col-12 col-sm-6">
            <InputText v-if="!store.form.sameInvoiceAddressOwnSeat" v-model="store.order.contactInfo.address.invoiceAddress.city" label-name="personalForm.city"
                       id="city"
                       required="personalForm.required.city" step="stepThree"/>
            <InputText v-if="store.form.sameInvoiceAddressOwnSeat" v-model="store.order.contactInfo.address.invoiceAddress.city" label-name="personalForm.city"
                       id="city"
                       required="personalForm.required.city" step="stepThree" disabled="disabled"/>
          </div>

<!--          INPUT PSC START-->
          <div class="col-12 col-sm-6">
            <div v-if="!store.form.sameInvoiceAddressOwnSeat" class="form-label-group mb-1">
              <input type="text" id="postCode" class="form-control"
                     :class="{'is-invalid': isBlurred() && !store.order.contactInfo.address.invoiceAddress.psc}"
                     v-model="store.order.contactInfo.address.invoiceAddress.psc"
                     v-on:input="preventPscInputFromLetter"
                     v-on:change="store.pscFilterInvoice()"
                     :placeholder="t('personalForm.psc')"
                     required=""/>
              <label for="postCode"> {{ t('personalForm.psc') }}</label>
              <div id="validationServer05Feedback" class="invalid-feedback">
                {{ t('personalForm.required.psc') }}
              </div>
            </div>
            <div v-else class="form-label-group mb-1">
              <input type="text" id="postCode" class="form-control"
                     :class="{'is-invalid': isBlurred() && !store.order.contactInfo.address.invoiceAddress.psc}"
                     v-model="store.order.contactInfo.address.invoiceAddress.psc"
                     v-on:input="preventPscInputFromLetter"
                     v-on:change="store.pscFilterInvoice()"
                     :placeholder="t('personalForm.psc')"
                     required="" disabled=""/>
              <label for="postCode"> {{ t('personalForm.psc') }}</label>
              <div id="validationServer05Feedback" class="invalid-feedback">
                {{ t('personalForm.required.psc') }}
              </div>
            </div>
          </div>
<!--          INPUT PSC END-->


          <!--          INPUT ZEMĚ START-->
          <div v-if="!store.form.sameInvoiceAddressOwnSeat" class="col-12 col-md-6">
            <div class="dropdown jake-dropdown mb-3"
                 v-if="store.order.contactInfo.address.invoiceAddress.country.value !== 'others'">
              <span class="label">{{ t('personalForm.country') }}</span>
              <a class=" dropdown-toggle" href="#" role="button" id="dropdownPhone" data-toggle="dropdown"
                 aria-expanded="false">
              <span v-if="store.order.contactInfo.address.invoiceAddress.country">

                {{ t('personalForm.countries.' + store.order.contactInfo.address.invoiceAddress.country.value) }}
              </span>
              </a>

              <div class="dropdown-menu shadow" aria-labelledby="dropdownPhone">
                    <span class="dropdown-item-text text-uppercase text-muted">
            <small>Vyberte zemi</small></span>
                <span class="dropdown-item cursorLink" v-for="item in countries"
                      @click="setCountry(item)">
         <img v-if="item.iconFile" width="20" style="vertical-align: text-bottom"
              v-bind:src="item.iconFile" alt=""/>
                  {{ t('personalForm.countries.' + item.value) }}
                </span>

              </div>
            </div>
            <div class="position-relative">
              <InputText
                  v-if="store.order.contactInfo.address.invoiceAddress.country &&store.order.contactInfo.address.invoiceAddress.country.value === 'others'"
                  v-model="store.order.contactInfo.address.invoiceAddress.otherCountry"
                  label-name="personalForm.country"
                  id="otherCountry"
                  required="Prosím vyplňte zemi" step="stepThree"/>
              <span v-if="store.order.contactInfo.address.invoiceAddress.country.value === 'others'" class="clearButton"
                    v-on:click="selectCzechCountry"><i
                  class="fa fa-times"></i> </span>
            </div>
          </div>

<!--          INPUT ZEME IF CHECKBOX-->
          <div v-else class="col-12 col-sm-6">
            <div class="dropdown jake-dropdown mb-3"
                 v-if="store.order.contactInfo.address.invoiceAddress.country.value !== 'others'">
              <span class="label">{{ t('personalForm.country') }}</span>
              <span class="dropdown-toggle dropdown-no-after" href="#" role="button" style="color: #8A8A8A; pointer-events: none;"
                 aria-expanded="false">
                {{ t('personalForm.countries.' + store.order.contactInfo.address.companyAddress.country.value) }}
              </span>
              <div class="position-absolute" style=" right: 10px; top: 12px; ">
                <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1L7 7L13 1" stroke="#BDBDBD" stroke-width="1.33" stroke-linecap="round"
                        stroke-linejoin="round"/>
                </svg>
              </div>
            </div>
          </div>
<!--          INPUT ZEME END-->



        </div>

        <div class="row text-left">

          <span class="h6 col-12 text-primary mt-3 mb-2 font-weight-bold">{{
              t('personalForm.headers.ostatniUdaje')
            }}</span>

          <!--          INPUT PAYMENT START-->
          <div class="col-12 col-md-6" v-if="store.order.type === 'order'">
            <div class="dropdown jake-dropdown">
              <span class="label">{{ t('payment.paymentType') }}</span>
              <a class=" dropdown-toggle" :class="{'is-invalid text-danger' : isBlurred() && !paymentTypeChoosen}" href="#"
                 role="button" id="dropdownPayment" data-toggle="dropdown"
                 aria-expanded="false">
              <span v-if="store.order.paymentType">
              {{ t(store.order.paymentType) }}
              </span>
                <span v-else>
            {{ t('payment.callToActionText') }}

                </span>
              </a>
              <!--              <span v-if="store.order.paymentType" class="clearButton" v-on:click="clearPaymentType"><i-->
              <!--                  class="fa fa-times"></i> </span>-->

              <div class="dropdown-menu shadow" aria-labelledby="dropdownHealth">
          <span class="dropdown-item-text text-uppercase text-muted">
            <small>{{ t('payment.callToActionText') }}</small></span>
                <a class="dropdown-item" href="#" v-for="item in paymentsTypes"
                   :class="{'text-secondary': item === store.order.paymentType}"
                   @click.prevent="setPaymentType(item)">
                  {{ t(item) }}
                </a>

              </div>
            </div>
            <div v-if="isBlurred() && !paymentTypeChoosen"
                 class="small error-block text-danger mt-1">
              {{ t('personalForm.required.paymentType') }}
            </div>
          </div>
          <!--        INPUT PAYMENT END-->

          <!--          INPUT POZNAMKA-->
          <div class="col-12 col-sm-6">
            <InputText v-model="store.order.contactInfo.poznamka"
                       label-name="personalForm.poznamka" id="surName"
                       step="stepThree"/>
          </div>
        </div>

        <div class="row mt-2">
          <div class="px-0 px-md-3 col-12 col-md-5 order-last order-md-first text-center text-md-left">
            <div class="px-3">
              <hr class="d-md-none mt-4">
            </div>
            <NeedHelp/>
          </div>
          <div class="col-12 col-md-7 pl-0 pb-0 pb-md-4 text-right d-none d-md-block">

            <button class="btn btn-primary mr-md-3 px-4 " type="button" @click='previousStep'>{{ t('buttons.zpet') }}
            </button>
            <button class="btn btn-secondary px-4" type="button" @click="nextStep"> {{ t('buttons.pokracovat') }}
            </button>

          </div>
          <div class="col-12 col-md-7 pb-md-4 d-md-none">

            <div class="row">
              <div class="col-7 text-left">
                <button class="btn btn-sm btn-primary px-2  " type="button" @click='previousStep'>
                  {{ t('buttons.zpet') }}
                </button>

              </div>
              <div class="col-5 text-right">
                <button class="btn btn-sm btn-secondary px-3" type="button" @click="nextStep">
                  {{ t('buttons.pokracovat') }}
                </button>

              </div>
            </div>


          </div>

        </div>


      </div>

    </div>
  </div>

</template>

<script>
import {useI18n} from "vue-i18n";
import {ref} from 'vue'
import {store} from "../store.js";
import InputText from "../FormsInputs/inputText.vue";
import TotalPrice from "../others/TotalPrice.vue";
import TotalPriceOfProducts from "../others/TotalPriceOfProducts.vue";
import Steps from "../others/StepsComponent/Steps.vue";
import NeedHelp from "@/components/others/NeedHelp.vue";
import flagCz from "@/assets/imgs/flags/cz.png";
import flagSk from "@/assets/imgs/flags/sk.png";
import flagDe from "@/assets/imgs/flags/de.png";
import flagPl from "@/assets/imgs/flags/pl.png";
import flagGb from "@/assets/imgs/flags/gb.png";
import flagFr from "@/assets/imgs/flags/fr.png";
import axios from "axios";

export default {
  name: "StepThree",
  components: {NeedHelp, Steps, TotalPriceOfProducts, TotalPrice, InputText},
  props: ['currentStep'],

  setup() {
    const {t} = useI18n({useScope: 'global'})
    const select = ref(0)
    return {t, select}
  },
  data() {
    return {
      errors: [],
      store,
      countries: [
        {
          value: 'czechia',
          iconName: 'cz.png',
          iconFile: flagCz,
          code: 'CZ'
        },
        {
          value: 'slovakia',
          iconName: 'sk.png',
          iconFile: flagSk,
          code: 'SK'
        },
        {
          value: 'germany',
          iconName: 'de.png',
          iconFile: flagDe,
          code: 'DE'
        },
        {
          value: 'polish',
          iconName: 'pl.png',
          iconFile: flagPl,
          code: 'PL'

        },
        {
          value: 'greatBritain',
          iconName: 'gb.png',
          iconFile: flagGb,
          code: 'GB'
        },
        {
          value: 'france',
          iconName: 'fr.png',
          iconFile: flagFr,
          code: 'FR'
        },
        {
          value: 'others',
          iconName: null,
          code: null
        },
      ],
      paymentsTypes: ['payment.card', 'payment.bank'],
      paymentTypes: ["payment.callToActionText", 'payment.card', 'payment.bank'],
      aresLoading: false,
    }
  },
  methods: {
    sameInvoiceAddressCheckBoxChanged() {
      if (this.store.form.sameInvoiceAddressOwnSeat) {
        this.store.order.contactInfo.address.invoiceAddress = {...this.store.order.contactInfo.address.companyAddress};
      }
      // pro nově vznikající subjekt se údaje propíší z vyrtuálního sídla
      if(this.store.form.sameInvoiceAddressOwnSeat && this.store.form.mamIco === 'nemam'){
        const sidlo = this.store.getSeatProduct()[0];
        this.store.order.contactInfo.address.invoiceAddress.psc = this.t('sidla.psc.'+sidlo.codeForTran);
        this.store.order.contactInfo.address.invoiceAddress.city = this.t('sidla.obec.'+sidlo.codeForTran);
        this.store.order.contactInfo.address.invoiceAddress.street = this.t('sidla.ulice.'+sidlo.codeForTran);
      }
    },
    loadFromAres(){
      if (this.store.order.contactInfo.address.invoiceAddress.ico.length !== 8) {
        this.wrongIco = true;
        return;
      } else {
        this.wrongIco = false;
      }
      // console.log("loading from ares");
      this.aresLoading = true;

      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: 'https://ares.gov.cz/ekonomicke-subjekty-v-be/rest/ekonomicke-subjekty/' + this.store.order.contactInfo.address.invoiceAddress.ico,
        headers: {}
      };

      axios.request(config)
          .then((response) => {
            //clear
            this.store.order.contactInfo.address.invoiceAddress.dic = '';
            this.store.order.contactInfo.address.invoiceAddress.companyName = '';
            this.store.order.contactInfo.address.invoiceAddress.street = '';
            this.store.order.contactInfo.address.invoiceAddress.psc = '';
            this.store.order.contactInfo.address.invoiceAddress.city = '';

            const data = response.data;

            if (data.dic) {
              this.store.order.contactInfo.address.invoiceAddress.dic = data.dic;
            }
            if (data.obchodniJmeno) {
              this.store.order.contactInfo.address.invoiceAddress.companyName = data.obchodniJmeno;
            }
            if (data.sidlo.nazevUlice) {
              this.store.order.contactInfo.address.invoiceAddress.street = data.sidlo.nazevUlice;
            }
            if (data.sidlo.cisloDomovni)
              this.store.order.contactInfo.address.invoiceAddress.street += ' ' + data.sidlo.cisloDomovni;
            if (data.sidlo.psc) {
              this.store.order.contactInfo.address.invoiceAddress.psc = data.sidlo.psc;
            }
            if (data.sidlo.nazevObce) {
              this.store.order.contactInfo.address.invoiceAddress.city = data.sidlo.nazevObce;
            }
            //konec loadingu
            this.aresLoading = false;
          }).catch((e) => {
        // console.log(e);
        this.aresLoading = false;
      });
    },
    setPaymentType(item) {
      this.store.order.paymentType = item;
    },
    setCountry(item) {
      this.store.order.contactInfo.address.invoiceAddress.country = item;
    },
    isBlurred() {
      return this.store.form.steps.stepThree.blurred;
    },
    finishStepEmit(name) {
      //console.log(`hello world`);
      this.nextStep();
    },
    checkStep() {
      if (this.store.form.mamIco === 'mam') {
        if (!this.store.order.contactInfo.address.invoiceAddress.ico) return false;
        // if (!this.store.order.contactInfo.address.invoiceAddress.dic) return false;
      }
      if (!this.store.order.contactInfo.address.invoiceAddress.companyName) return false;
      if (!this.store.order.contactInfo.address.invoiceAddress.street) return false;
      if (!this.store.order.contactInfo.address.invoiceAddress.city) return false;
      if (!this.store.order.contactInfo.address.invoiceAddress.psc) return false;
      if (!this.store.order.contactInfo.address.invoiceAddress.country) return false;
      if (!this.paymentTypeChoosen) return false;
      return true;
    },
    nextStep() {
      this.store.form.steps.stepThree.blurred = true;

      var check = this.checkStep();
      // console.log('check: ' + check);
      if (check) {
        this.sameInvoiceAddressCheckBoxChanged();
        this.store.form.steps.stepThree.visited = true;
        this.store.form.steps.stepThree.filled = true;
        this.store.form.currentStep = 'stepFour';
        this.store.seatClarityEvent('before-order-finish');
        this.store.vueClarityEvent('before-order-finish');
        this.store.gaEventNextStep('step4');
        this.store.scrollTop();
      }else{
        this.$nextTick(()=>{
          this.store.scrollToErrorInput();
        })
      }
    },
    preventPscInputFromLetter() {
      // store.order.ownSeatAddress.psc = store.order.ownSeatAddress.psc.replace(/\D/g, '').substring(0, 5);
      store.order.contactInfo.address.invoiceAddress.psc = store.order.contactInfo.address.invoiceAddress.psc.replace(/\D/g, '').substring(0, 5);
    },
    preventIcoInputFromLetter() {
      // store.order.ownSeatAddress.psc = store.order.ownSeatAddress.psc.replace(/\D/g, '').substring(0, 5);
      store.order.contactInfo.address.invoiceAddress.ico = store.order.contactInfo.address.invoiceAddress.ico.replace(/\D/g, '').substring(0, 8);
    },
    previousStep() {
      // console.log('back step');
      // this.store.form.currentStep = 'stepTwo';
      // this.store.previousStep();
      this.store.goToStep('stepTwo');

    },
    selectCzechCountry() {
      var countries = this.countries.filter(function (elem) {
        if (elem.value === "czechia") return elem;
      });
      this.store.order.contactInfo.address.invoiceAddress.country = countries[0];
    },

  },
  computed: {
    sameInvoiceAddressIsChecked() {
      return this.store.form.sameInvoiceAddressOwnSeat;
    },
    paymentTypeChoosen() {
      return this.store.order.paymentType !== 'payment.callToActionText';
    },

  }, created() {
    this.selectCzechCountry();
  },

}
</script>

<style lang="scss" scoped>
.table {
  font-size: 15px;

}
.clearButton {
  position: absolute;
  display: block;
  width: 20px;
  height: 20px;
  //border: 1px solid red;
  text-align: center;
  bottom: 1px;
  right: 0px;
  font-size: 12px;
  z-index: +1000;
  cursor: pointer;

}
.ares-button{
  position: absolute;
  display: block;
  z-index: +1000;
  top: 16px;
  right: 0px;
}
</style>
